import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  token: null,
  userId: null,
  role: null,
  error: null,
  loading: false,
  company: null,
  sections: [],
  authRedirectPath: "/"
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SECTIONS_BEGIN:
    case actionTypes.AUTH_START:
    case actionTypes.FETCH_COMPANY_BEGIN:
    case actionTypes.UPDATE_COMPANY_BEGIN:
      return updateObject(state, { loading: true, error: null });
    case actionTypes.AUTH_SUCCESS:
      return updateObject(state, {
        token: action.idToken,
        userId: action.userId,
        role: action.role,
        error: null,
        loading: false,
        company: null,
        sections: []
      });
    case actionTypes.FETCH_COMPANY_SUCCESS:
      return updateObject(state, {
        error: null,
        loading: false,
        company: action.payload.company
      });
    case actionTypes.FETCH_SECTIONS_SUCCESS:
      return updateObject(state, {
        error: null,
        loading: false,
        sections: action.payload.sections
      });
    case actionTypes.UPDATE_COMPANY_SUCCESS:
      return updateObject(state, {
        loading: false,
        error: null,
        company: action.payload.company
      });
    case actionTypes.UPDATE_COMPANY_FAILED:
    case actionTypes.AUTH_FAIL:
    case actionTypes.FETCH_COMPANY_FAILED:
    case actionTypes.FETCH_SECTIONS_FAILED:
      return updateObject(state, { error: action.error, loading: false });
    case actionTypes.AUTH_LOGOUT:
      return updateObject(state, {
        token: null,
        userId: null,
        role: null,
        company: null,
        error: null,
        loading: false,
        user: null
      });
    case actionTypes.SET_AUTH_REDIRECT_PATH:
      return updateObject(state, { authRedirectPath: action.path });
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js